export const msalConfig = {
  auth: {
    clientId: "9217d805-f2a1-43b5-83bd-faf18cb6eeea", // Application (client) ID
    authority: "https://login.microsoftonline.com/9217d805-f2a1-43b5-83bd-faf18cb6eeea", // Tenant ID
    redirectUri: "http://localhost:3000/login",
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};




export const loginRequest = {
  scopes: ["openid", "profile", "email", "api://YOUR_APP_ID/access_as_user"]  
  // include scopes for your backend, Graph if needed
};
